class UniversalAnalytics {
    constructor() {
        this.eventListeners = [];
        this.addEventListener = (listener) => {
            this.eventListeners.push(listener);
        };
    }
    sendEvent(category, action, label = '', value = 0, extraData) {
        console.log('Sending Event', { category, action, label, value });
        for (let listener of this.eventListeners) {
            try {
                listener.track(category, action, label, value, extraData);
            }
            catch (e) {
                console.log(e);
            }
        }
    }
    sendSubscriberHomepageEvent(type) {
        this.sendEvent('Subscriber Homepage', type);
    }
    trackAddToCart(item) {
        this.klayviyoAddToCart(item);
        this.pintrkAddToCart(item);
        this.gtmAddToCart(item);
        this.optimizelyAddToCart(item);
    }
    optimizelyAddToCart(item) {
        try {
            let price = item.price;
            if (item.isSubscription) {
                price = Number(item.variantSubscriptionPrice.replace(".", ""));
            }
            const value = (price / 100).toFixed(2);
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: "event",
                eventName: "add-to-cart",
                tags: {
                    revenue: price,
                    value: value
                }
            });
        }
        catch (error) {
        }
    }
    klayviyoAddToCart(item) {
        const klaviyoItem = {
            Name: item.variantTitle,
            ProductID: item.variantId,
            Categories: window.vitalData.itemCategories,
            ImageURL: item.featured_image.src,
            URL: window.location.href,
            Brand: 'Vital Proteins',
            Price: item.isSubscription
                ? item.variantSubscriptionPrice
                : item.variantStandardPrice,
            CompareAtPrice: item.compare_at_price,
        };
        _learnq && _learnq.push(['track', 'Added to Cart', klaviyoItem]);
    }
    pintrkAddToCart(item) {
        window.pintrk &&
            window.pintrk('track', 'addtocart', {
                value: item.isSubscription
                    ? Number(item.variantSubscriptionPrice.replace(/[^\d.-]+/g, ''))
                    : Number(item.variantStandardPrice.replace(/[^\d.-]+/g, '')),
                order_quantity: item.quantity,
                currency: 'USD',
                line_items: [
                    {
                        product_id: item.isSubscription
                            ? item.sellingPlans
                            : item.variantId,
                    },
                ],
            });
    }
    /**
     * Google Tag Manager add to cart event
     */
    gtmAddToCart(item) {
        globalThis.dataLayer = globalThis.dataLayer || [];
        globalThis.dataLayer.push({
            event: 'redditPixelAddToCart',
            redditPixelAddToCartCurrency: 'USD',
            redditPixelAddToCartTransactionValue: Number(item.isSubscription
                ? item.variantSubscriptionPrice
                : item.variantStandardPrice) * item.quantity,
            redditPixelAddToCartItemCount: item.quantity,
        });
    }
}
export const Analytics = new UniversalAnalytics();
